"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const React = __importStar(require("react"));
const Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
const react_router_dom_1 = require("react-router-dom");
const BottomBar_1 = __importDefault(require("./components/BottomBar"));
const MobileMenu_1 = __importDefault(require("./components/MobileMenu"));
const TopBar_1 = __importDefault(require("./components/TopBar"));
const useBreakpoints_1 = require("../utils/useBreakpoints");
const Container_1 = __importDefault(require("../common/Container/Container"));
const themes_1 = require("../../themes");
const Header = ({ menuElements, isLoggedIn, accountLinks, logo, notifications, messages, mobileAccountLinks, buttonsSettings, themeVariant, additionalContent, hideLoginRegister, hideMobileMenu, sx = {}, }) => {
    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
    const breakpoints = (0, useBreakpoints_1.useBreakpoints)(['smDown', 'smUp']);
    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };
    return (React.createElement(AppBar_1.default, { elevation: 0, sx: Object.assign({ background: 'white', color: 'grey.900', fontSize: 14, '& svg': {
                fontSize: 20,
            }, height: 'auto', position: 'sticky', boxShadow: '0 1px 4px #19316f60' }, sx) },
        React.createElement(Container_1.default, null,
            React.createElement(Toolbar_1.default, { sx: {
                    '&.MuiToolbar-root': {
                        padding: 0,
                        minHeight: {
                            xs: 64,
                            sm: 72,
                        },
                    },
                } },
                logo.external && (React.createElement("a", { href: logo.url },
                    React.createElement("img", { src: logo.image, alt: "logo", height: "32" }))),
                !logo.external && (React.createElement(react_router_dom_1.Link, { to: logo.url },
                    React.createElement("img", { src: logo.image, alt: "logo", height: "32" }))),
                React.createElement(Box_1.default, { sx: { flexGrow: 1 } }, additionalContent),
                React.createElement(TopBar_1.default, { isLoggedIn: isLoggedIn, notifications: notifications, messages: messages, accountLinks: accountLinks, buttonsSettings: buttonsSettings, hideLoginRegister: hideLoginRegister }),
                breakpoints.smDown && !hideMobileMenu && (React.createElement(IconButton_1.default, { color: "inherit", onClick: toggleDrawer, sx: { marginLeft: themes_1.Spacings.small3 } },
                    React.createElement(Menu_1.default, null)))),
            React.createElement(Divider_1.default, { sx: {
                    position: 'absolute',
                    width: '100%',
                    left: 0,
                    borderColor: 'grey.400',
                } }),
            isLoggedIn && breakpoints.smUp && (React.createElement(BottomBar_1.default, { menuElements: menuElements })),
            breakpoints.smDown && (React.createElement(MobileMenu_1.default, { isDrawerOpen: isDrawerOpen, toggleDrawer: toggleDrawer, menuElements: menuElements, mobileAccountLinks: mobileAccountLinks, isLoggedIn: isLoggedIn, buttonsSettings: buttonsSettings, themeVariant: themeVariant })))));
};
exports.default = Header;
